<div fxLayout="column" fxLayoutAlign="space-evenly stretch" style="margin:5px">
  <!--  <div fxLayout="row" fxLayoutGap="10px" style="margin-bottom: 5px">-->
  <!--    <div kendoTooltip style="text-align: center; padding-top: 5px;">-->
  <!--      <input kendoTextBox title="Example: 7050 or BEANS or BEAN% or %BEANS"/>-->
  <!--    </div>-->
  <!--    <app-mcl-button text="GL Code Lookup" primary="true" (click)="glCodeLookup()">-->
  <!--    </app-mcl-button>-->
  <!--  </div>-->
  <form novalidate #myForm="ngForm">
    <kendo-grid
      [kendoGridBinding]="gridData"
      [kendoGridSelectBy]="selectedCallback"
      [selectedKeys]="mySelection"
      (dataStateChange)="onStateChange($event)"
      (edit)="editHandler($event)" (cancel)="cancelHandler($event)"
      (save)="saveHandler($event)" (remove)="removeHandler($event)"
      (add)="addHandler($event, myForm)"
      [filterable]="true"
      [resizable]="true"
      [sortable]="true"
      [scrollable]="true"
      [pageSize]="gridState.take" [skip]="gridState.skip" [sort]="gridState.sort"
      [pageable]="{
                  buttonCount: 5,
                  info: true,
                  type: 'numeric',
                  pageSizes: [20, 40, 60],
                  previousNext: true
                 }"
      style="height: 70vh">

      <!--      <kendo-grid-checkbox-column title="Remove" [width]="45">-->
      <!--        <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">-->
      <!--          <input *ngIf="dataItem.removable"-->
      <!--                 [disabled]="!dataItem.removable === true"-->
      <!--                 type="checkbox"-->
      <!--                 class="k-checkbox"-->
      <!--                 id="checkbox-{{rowIndex}}"-->
      <!--                 [kendoGridSelectionCheckbox]="rowIndex"-->
      <!--          />-->
      <!--          <label class="k-checkbox-label"-->
      <!--                 for="checkbox-{{rowIndex}}">-->
      <!--          </label>-->
      <!--        </ng-template>-->
      <!--      </kendo-grid-checkbox-column>-->
      <kendo-grid-column field="glCode" title="GL Code" filterable="true" [width]="150"></kendo-grid-column>
      <kendo-grid-column field="glDesc" title="GL Description" filterable="true" [width]="150">
        <ng-template kendoGridEditTemplate let-dataItem="dataItem">
          <input [(ngModel)]="dataItem.glDesc" kendoGridFocusable name="glDesc" class="k-textbox" required/>
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-command-column title="Item Details" width="150">
        <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
          <app-mcl-button *ngIf="!dataItem.removable" text="Items.." primary="true" (click)="goToItemDetails(dataItem)">
          </app-mcl-button>
        </ng-template>
      </kendo-grid-command-column>

      <kendo-grid-command-column title="Actions" width="100">
        <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
           <button kendoGridEditCommand [primary]="true" style="margin-right: 8px; min-width: 60px;">Edit</button> 
           <button *ngIf="dataItem.removable" kendoGridRemoveCommand >Delete</button> 
          <button
            kendoGridSaveCommand 
            [disabled]="myForm.invalid || myForm.pristine" [primary]="true" style="margin-right: 8px;">Update </button>
          <button kendoGridCancelCommand >Cancel</button>
        </ng-template>
      </kendo-grid-command-column>
    </kendo-grid>
  </form>


  <div fxLayout="row" fxLayoutGap="10px" fxLayoutAlign="end stretch" style="margin-top: 10px">
    <app-mcl-button text="Add" primary="true" (click)="add()">
    </app-mcl-button>

    <!--    <app-mcl-button text="Update" primary="true" (click)="update()">-->
    <!--    </app-mcl-button>-->

    <!--    <app-mcl-button text="Delete" primary="true" (click)="delete()">-->
    <!--    </app-mcl-button>-->
  </div>

</div>

<div kendoDialogContainer></div>

